export default __webpack_public_path__ + "static/media/SAKS_WHITE.5b543323.png";